import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notice", "latitude", "longitude", "lookup"]

  connect() {}

  search(event) {
    event.preventDefault()
    const lookupValue = this.lookupTarget.value

    fetch(this.element.action, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ lookup: lookupValue })
    })
      .then(response => response.json())
      .then(data => {
        if (data.result) {
          this.latitudeTarget.value = data.result.latitude.toFixed(5)
          this.longitudeTarget.value = data.result.longitude.toFixed(5)

          const marker = {
            lat: data.result.latitude,
            lon: data.result.longitude
          }

          clearMarkers(window.map)
          L.marker(marker).addTo(window.markers)
          window.markers.addTo(window.map)
          window.map.setView(marker, 10)
        } else {
          this.noticeTarget.innerHTML = data.message
          this.noticeTarget.style.display = ""
          setTimeout(() => {
            this.noticeTarget.style.transition = "opacity 1s"
            this.noticeTarget.style.opacity = 0
            setTimeout(() => {
              this.noticeTarget.style.display = "none"
              this.noticeTarget.style.opacity = 1
              this.noticeTarget.style.transition = ""
            }, 1000)
          }, 5000)
        }
      })
  }
}